import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=dbbb149a&scoped=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackForm.vue?vue&type=style&index=0&id=dbbb149a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbb149a",
  null
  
)

export default component.exports